var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.25L4.9375 9.1875L6.22917 7.89583C4.40972 7.70139 2.91667 7.23611 1.75 6.5C0.583333 5.76389 0 4.93056 0 4C0 2.88889 0.777778 1.94444 2.33333 1.16667C3.88889 0.388889 5.77778 0 8 0C10.2222 0 12.1111 0.388889 13.6667 1.16667C15.2222 1.94444 16 2.88889 16 4C16 4.83333 15.5451 5.58681 14.6354 6.26042C13.7257 6.93403 12.5139 7.41667 11 7.70833V6.16667C12 5.93056 12.8333 5.60764 13.5 5.19792C14.1667 4.78819 14.5 4.38889 14.5 4C14.5 3.36111 13.8264 2.78472 12.4792 2.27083C11.1319 1.75694 9.63889 1.5 8 1.5C6.375 1.5 4.88542 1.76042 3.53125 2.28125C2.17708 2.80208 1.5 3.375 1.5 4C1.5 4.47222 1.94792 4.94444 2.84375 5.41667C3.73958 5.88889 4.78472 6.20139 5.97917 6.35417L4.9375 5.3125L6 4.25L9 7.25L6 10.25Z",
    fill: "#1B436E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedIcon);
export default __webpack_public_path__ + "static/media/missed_icon.14b6c30affeb81880c71573f1d8399af.svg";
export { ForwardRef as ReactComponent };